import { SPORTS } from '@/lib/constants';

export default function getSportName(sportId: number) {
  if (!sportId) {
    return '';
  }

  const sport = SPORTS.find((sport) => sport.id === sportId);
  return sport?.name;
}